<template>
  <div class="Map" data-cy="map">
    <l-map ref="map" :zoom="zoom" :center="center" :options="options">
      <l-tile-layer :url="url" :attribution="attribution" />
      <slot name="marker"></slot>
      <slot name="content"></slot>
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

export default {
  name: 'Map',
  components: {
    LMap,
    LTileLayer
  },
  props: {
    center: {
      type: Array,
      default: () => [51.504, -0.159]
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    return {
      url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
      zoom: 15,
      markerLatLng: [51.504, -0.159],
      attribution:
        '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
    };
  }
};
</script>

<style>
.Map {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
}
</style>
